import React, { useState, useRef } from "react";
import { Link } from "react-router-dom";
import {
  FaArrowRight,
  FaFilter,
  FaMapMarkerAlt,
  FaCalendarAlt,
  FaUsers,
  FaGlobeAfrica,
  FaPaperPlane,
  FaHiking,
  FaUmbrellaBeach,
  FaChevronDown,
} from "react-icons/fa";
import "../css/styles.css";
import { API_BASE, parseJsonResponse } from "../api";

const cloudImg = (path) =>
  `https://res.cloudinary.com/dn39bkkiq/image/upload/q_auto,f_auto,w_800/${path}`;

/* ─── SAFARI DATA ─── */
const kenyaSafaris = [
  { img: cloudImg("v1776348869/3_Days_Masai_mara_Express_Safari_2_gjcw8a.jpg"), title: "3 Day Masai Mara Express Safari", bestFor: ["Family", "Adventure", "Couples"], badge: "Best Selling", route: "/wildebeest-migration" },
  { img: cloudImg("v1776348587/6_Day_Kilimanjaro_Tsavo_Safari_kwzzin.jpg"), title: "6 Day Kilimanjaro & Tsavo Safari", bestFor: ["Adventure", "Couples", "Exploration"], badge: "Best Selling", route: "/kilimanjaro-tsavo" },
  { img: cloudImg("v1776348690/7_Day_Highlights_of_kenya_safari_2_zynbfv.jpg"), title: "7 Day Highlights of Kenya Safari", bestFor: ["Couples", "Families"], badge: null, route: "/kenya-highlights" },
  { img: cloudImg("v1776348863/7_Day_big_5_Kenya_safari_lrcl0w.jpg"), title: "7 Day Big Five Kenya Safari", bestFor: ["Adventure", "Couples", "Luxury"], badge: null, route: "/big-five-kenya" },
  { img: cloudImg("v1776348685/8_Day_Best_of_Kenya_Luxury_Flying_Safari_Diani_Beach_2_g1mr45.jpg"), title: "8 Day Best of Kenya Luxury Flying Safari + Diani Beach", bestFor: ["Couples", "Luxury"], badge: "Best Selling", route: "/luxury-flying-safari" },
  { img: cloudImg("v1776348741/8_Days_Wild_Heart_Kenya_Safari_u0ichl.jpg"), title: "8 Day Kenya Wild Heart Safari", bestFor: ["Adventure", "Couples", "Exploration"], badge: "Best Selling", route: "/wild-heart-kenya" },
  { img: cloudImg("v1776348744/10_Days_Amboseli_Tsavo_Taita_Hills_Safari_Diani_Beach_jlqkip.jpg"), title: "10 Days Amboseli – Tsavo – Taita Hills + Diani Beach", bestFor: ["Adventure", "Couples", "Luxury"], badge: null, route: "/amboseli-tsavo-diani" },
];

const tanzaniaSafaris = [
  { img: cloudImg("v1776348629/6_Day_Serengeti_Migration_Safari_mkyfhv.jpg"), title: "6 Day Serengeti Migration Safari", bestFor: ["Adventure", "Couples"], badge: null, route: "/serengeti-migration" },
  { img: cloudImg("v1776348825/7_Day_Northern_Tanzania_Safari_mvpqrt.jpg"), title: "7 Day Northern Tanzania Safari", bestFor: ["Adventure", "Couples", "Families"], badge: "Best Selling", route: "/northern-tanzania" },
  { img: cloudImg("v1776348758/10_Day_Tanzania_Safari_Zanzibar_hohxsc.jpg"), title: "10 Day Tanzania Safari & Zanzibar", bestFor: ["Luxury", "Romance"], badge: "Best Selling", route: "/tanzania-zanzibar" },
];

const comboSafaris = [
  { img: cloudImg("v1776348883/10_Day_Kenya_Tanzania_Highlights_osh7bf.jpg"), title: "10 Day Kenya & Tanzania Highlights", bestFor: ["Couples", "Adventure", "Discovery"], badge: "Best Selling", route: "/kenya-tanzania-highlights" },
  { img: cloudImg("v1776348858/14_Day_East_Africa_Grand_Safari_ji9lxl.jpg"), title: "14 Day East Africa Grand Safari", bestFor: ["Couples", "Adventure", "Discovery"], badge: "Best Selling", route: "/east-africa-grand" },
  { img: cloudImg("v1776348819/Ultimate_East_Africa_Luxury_Safari_d9opmh.jpg"), title: "Ultimate East Africa Luxury Safari", bestFor: ["Luxury", "Romance"], badge: null, route: "/ultimate-luxury-safari" },
];

/* ─── EXCURSIONS ─── */
const kenyaExcursions = [
  "Nairobi City Tour – Explore Nairobi's main attractions in a day",
  "Mombasa Day Tour – Popular historical and cultural sites",
  "Diani – Snorkeling & Dolphin Tour at Wasini & Kisite Mpunguti",
  "Diani & Watamu – Dhow Sunset Cruise",
  "Watamu – Snorkeling & Dolphin Tour at Watamu Marine Park",
];

const tanzaniaExcursions = [
  "Arusha Coffee & Spice Plantation Tours",
  "Cultural Village Visits (Maasai, Hadzabe tribes)",
];

const kenyaExcursionsExtra = [
  "Lake Naivasha – Boat Ride & Crescent Island Tour",
  "Masai Village Visit in Masai Mara",
  "Samburu Cultural Village Visit",
  "Masai Mara & Serengeti Hot Air Balloon Safari",
];

const zanzibarExcursions = [
  { category: "Cultural & Historical", items: [
    "Stone Town Walking Tour – Explore the UNESCO heritage streets, spice markets, and historic architecture",
    "Spice Farm Tour – Visit spice plantations to see cloves, nutmeg, cinnamon, vanilla, and other tropical spices",
    "Prison Island (Changuu Island) Visit – Meet giant tortoises and learn the island's history",
  ]},
  { category: "Beach & Marine Activities", items: [
    "Snorkeling & Diving at Mnemba Atoll – Explore colorful coral reefs and vibrant marine life",
    "Private Island Picnic / Sandbank Tour – Day trip to a secluded beach or sandbank",
    "Dhow Sunset Cruise – Traditional sailing along the coast at sunset",
    "Kite Surfing / Paddleboarding – Adventure water sports at Nungwi or Paje beaches",
  ]},
];

const categories = [
  { id: "kenya", label: "Kenya Safaris", safaris: kenyaSafaris, icon: <FaHiking /> },
  { id: "tanzania", label: "Tanzania Safaris", safaris: tanzaniaSafaris, icon: <FaGlobeAfrica /> },
  { id: "combo", label: "Kenya & Tanzania Combo", safaris: comboSafaris, icon: <FaMapMarkerAlt /> },
];

const allFilters = ["All", "Adventure", "Couples", "Families", "Luxury", "Romance", "Exploration", "Discovery"];

const Travelpackages = () => {
  const [activeCategory, setActiveCategory] = useState("kenya");
  const [activeFilter, setActiveFilter] = useState("All");
  const [showExcursions, setShowExcursions] = useState(false);
  const [form, setForm] = useState({ name: "", email: "", destination: "", travelers: "", travelDate: "", message: "" });
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const formRef = useRef(null);

  const currentCategory = categories.find((c) => c.id === activeCategory);
  const filtered =
    activeFilter === "All"
      ? currentCategory.safaris
      : currentCategory.safaris.filter((s) => s.bestFor.includes(activeFilter));

  const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      const res = await fetch(`${API_BASE}/api/booking`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ name: form.name, email: form.email, destination: form.destination, travelers: form.travelers, date: form.travelDate, message: form.message }),
      });
      const data = await parseJsonResponse(res);
      if (!res.ok) throw new Error(data.error || data.message || `Request failed ${res.status}`);
      setSubmitted(true);
      setForm({ name: "", email: "", destination: "", travelers: "", travelDate: "", message: "" });
      setTimeout(() => setSubmitted(false), 5000);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const scrollToForm = (safariTitle) => {
    setForm((f) => ({ ...f, message: `I'm interested in: ${safariTitle}` }));
    formRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div className="shop-page">
      {/* ===== HERO ===== */}
      <section className="shop-hero">
        <img
          src={cloudImg("v1776345019/Tours_Safaris_hero_lxnulg.jpg")}
          alt="Safari"
          className="shop-hero-bg"
        />
        <div className="shop-hero-overlay" />
        <div className="shop-hero-content">
          <span className="dest-hero-eyebrow">The Heart of Nyatwende</span>
          <h1 className="shop-hero-title">Safari Packages & Experiences</h1>
          <p className="shop-hero-sub">
            Handcrafted itineraries across Kenya, Tanzania & Zanzibar — from thrilling game drives to blissful beach escapes.
          </p>
          <div className="hero-buttons">
            <button onClick={() => formRef.current?.scrollIntoView({ behavior: "smooth" })} className="hero-cta primary">
              Customize Your Safari <FaArrowRight className="btn-icon" />
            </button>
            <Link to="/destinations" className="hero-cta secondary">
              Explore Destinations
            </Link>
          </div>
        </div>
      </section>

      {/* ===== CATEGORY TABS ===== */}
      <section className="shop-categories">
        <div className="shop-categories-inner">
          <span className="section-tag centered shop-tag">Browse Safaris</span>
          <h2 className="section-heading shop-heading">Choose Your Adventure</h2>

          <div className="shop-tabs">
            {categories.map((cat) => (
              <button
                key={cat.id}
                className={`shop-tab ${activeCategory === cat.id ? "active" : ""}`}
                onClick={() => { setActiveCategory(cat.id); setActiveFilter("All"); }}
              >
                <span className="shop-tab-icon">{cat.icon}</span>
                {cat.label}
              </button>
            ))}
          </div>

          {/* Filters */}
          <div className="shop-filters">
            <FaFilter className="shop-filters-icon" />
            {allFilters.map((f) => (
              <button
                key={f}
                className={`shop-filter-chip ${activeFilter === f ? "active" : ""}`}
                onClick={() => setActiveFilter(f)}
              >
                {f}
              </button>
            ))}
          </div>

          {/* Safari Grid */}
          <div className="shop-grid" key={activeCategory + activeFilter}>
            {filtered.length === 0 ? (
              <p className="shop-empty">No safaris match this filter. Try "All" to see everything.</p>
            ) : (
              filtered.map((safari, i) => (
                <div className="shop-card" key={i}>
                  <Link to={safari.route} className="shop-card-link">
                    <div className="shop-card-img-wrap">
                      <img src={safari.img} alt={safari.title} />
                      {safari.badge && <span className="shop-card-badge">{safari.badge}</span>}
                    </div>
                    <div className="shop-card-body">
                      <h3 className="shop-card-title">{safari.title}</h3>
                      <div className="shop-card-tags">
                        {safari.bestFor.map((tag, j) => (
                          <span className="shop-card-tag" key={j}>{tag}</span>
                        ))}
                      </div>
                      <span className="shop-card-view">
                        View Detailed Itinerary <FaArrowRight />
                      </span>
                    </div>
                  </Link>
                  <button className="shop-card-customize" onClick={() => scrollToForm(safari.title)}>
                    Customize This Safari <FaPaperPlane />
                  </button>
                </div>
              ))
            )}
          </div>
        </div>
      </section>

      {/* ===== EXCURSIONS ===== */}
      <section className="shop-excursions">
        <div className="shop-excursions-inner">
          <span className="section-tag centered">Day Adventures</span>
          <h2 className="section-heading">Excursions & Day Trips</h2>
          <p className="section-subheading shop-exc-sub">Add unforgettable experiences to your safari or enjoy them as standalone day trips</p>

          <button className="shop-exc-toggle" onClick={() => setShowExcursions(!showExcursions)}>
            {showExcursions ? "Hide" : "Show"} All Excursions <FaChevronDown className={`shop-exc-chevron ${showExcursions ? "open" : ""}`} />
          </button>

          {showExcursions && (
            <div className="shop-exc-grid">
              <div className="shop-exc-col">
                <h3><FaMapMarkerAlt /> Kenya</h3>
                <ul>{kenyaExcursions.map((e, i) => <li key={i}>{e}</li>)}</ul>
                <ul>{kenyaExcursionsExtra.map((e, i) => <li key={i}>{e}</li>)}</ul>
              </div>
              <div className="shop-exc-col">
                <h3><FaGlobeAfrica /> Tanzania</h3>
                <ul>{tanzaniaExcursions.map((e, i) => <li key={i}>{e}</li>)}</ul>
              </div>
              <div className="shop-exc-col">
                <h3><FaUmbrellaBeach /> Zanzibar</h3>
                {zanzibarExcursions.map((group, gi) => (
                  <div key={gi}>
                    <h4>{group.category}</h4>
                    <ul>{group.items.map((item, ii) => <li key={ii}>{item}</li>)}</ul>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      </section>

      {/* ===== CTA FORM ===== */}
      <section className="cta-section cta-clean" id="shop-customize" ref={formRef}>
        <div className="cta-content">
          <span className="cta-eyebrow">Design Your Dream Safari</span>
          <h2>Customize Your Safari</h2>
          <p>Tell us about your ideal adventure. Our experts will craft a personalised itinerary with handpicked lodges, private game drives, and unforgettable moments.</p>

          {error && <div className="modern-form-error"><p>{error}</p></div>}

          {submitted ? (
            <div className="modern-form-success">
              <div className="success-checkmark">&#10003;</div>
              <h3>Request Sent!</h3>
              <p>Our safari experts will reach out shortly with your custom itinerary.</p>
            </div>
          ) : (
            <form className="modern-form cta-inline-form" onSubmit={handleSubmit}>
              <div className="modern-form-grid">
                <div className="modern-form-group">
                  <label htmlFor="shop-name">Full Name</label>
                  <input id="shop-name" type="text" name="name" placeholder="Your full name" value={form.name} onChange={handleChange} required />
                </div>
                <div className="modern-form-group">
                  <label htmlFor="shop-email">Email Address</label>
                  <input id="shop-email" type="email" name="email" placeholder="you@example.com" value={form.email} onChange={handleChange} required />
                </div>
                <div className="modern-form-group">
                  <label htmlFor="shop-dest"><FaGlobeAfrica className="field-icon" /> Destination</label>
                  <select id="shop-dest" name="destination" value={form.destination} onChange={handleChange}>
                    <option value="">Pick a destination</option>
                    <option value="Kenya">Kenya</option>
                    <option value="Tanzania">Tanzania</option>
                    <option value="Kenya & Tanzania">Kenya & Tanzania Combo</option>
                    <option value="Zanzibar">Zanzibar</option>
                    <option value="Not Sure">Not Sure Yet</option>
                  </select>
                </div>
                <div className="modern-form-group">
                  <label htmlFor="shop-travelers"><FaUsers className="field-icon" /> Travelers</label>
                  <select id="shop-travelers" name="travelers" value={form.travelers} onChange={handleChange}>
                    <option value="">How many?</option>
                    <option value="1">Solo</option>
                    <option value="2">2 People</option>
                    <option value="3-5">3 – 5</option>
                    <option value="6-10">6 – 10</option>
                    <option value="10+">10+ Group</option>
                  </select>
                </div>
                <div className="modern-form-group">
                  <label htmlFor="shop-date"><FaCalendarAlt className="field-icon" /> Travel Date</label>
                  <input id="shop-date" type="date" name="travelDate" value={form.travelDate} onChange={handleChange} />
                </div>
              </div>
              <div className="modern-form-group full-width">
                <label htmlFor="shop-message">Tell Us More</label>
                <textarea id="shop-message" name="message" rows="4" placeholder="Which safari interests you? Any special requests, budget, or questions?" value={form.message} onChange={handleChange} />
              </div>
              <button type="submit" className="modern-form-submit cta-form-submit" disabled={loading}>
                {loading ? <span className="spinner-wrapper"><span className="spinner" /> Sending...</span> : <><FaPaperPlane /> Customize My Safari</>}
              </button>
            </form>
          )}
        </div>
      </section>
    </div>
  );
};

export default Travelpackages;